import React from "react";
import {useSelector, useDispatch} from "react-redux";
import useOnClickOutside from "use-onclickoutside";

import * as actionTypes from "../../store/actions/actionTypes";
import {dispatchMyRecoveryPatientUpdate} from "../../store/actions/modal";
import JSONPretty from 'react-json-pretty';

const ModalMyRecoveryData = () => {
    const {show, admission, patientData, journeyData, error} = useSelector(state => state.modal.myRecoveryData);

    const dispatch = useDispatch();
    const ref = React.useRef(null);
    useOnClickOutside(ref, () => hideModal());

    const hideModal = () => dispatch({type: actionTypes.MODAL_MY_RECOVERY_DATA_HIDE});
    const handleDispatchPatientUpdate = () => dispatch(dispatchMyRecoveryPatientUpdate(admission));

    const renderKeyValueTable = (data, title) => {
        if (!data || Object.keys(data).length === 0) {
            return <p>No {title} available.</p>;
        }
        return <JSONPretty data={data}/>
    }

    const renderModal = () => {
        return (
            <div className="modal-dialog" role="document" ref={ref}>
            <div className="modal-content modal-content-large">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={hideModal}>
                    <span aria-hidden="true">&times;</span>
                </button>
                <div className="modal-body">
                    <h3>MyRecovery Data for {admission.title} {admission.surname}, {admission.name}</h3>
                    {error ? (
                        <div className="alert alert-danger">{error}</div>
                    ) : (
                        <>
                            <div className="mb-3">
                                <button className="btn btn-sm btn-warning" onClick={handleDispatchPatientUpdate}>Dispatch Patient Update</button>
                            </div>

                            <h4>Patient Data</h4>
                            {renderKeyValueTable(patientData, 'patient data')}

                            <h4 className="mt-3">Journey Data</h4>
                            {renderKeyValueTable(journeyData, 'journey data')}
                        </>
                    )}
                </div>
            </div>
        </div>
        );
    }

    return (
        <>
            <div className={`modal fade ${show ? 'show' : ''}`} id="myRecoveryDataModal" tabIndex="-1">
                {show && renderModal()}
            </div>
        </>
    );
}

export default ModalMyRecoveryData;
